import { useMicrosoftClarity } from "@/hooks/useMicrosoftClarity";

export function ClarityProvider() {
  useMicrosoftClarity();
  return null;
}
